import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';

import { primaryGreen } from './primary-palette';
import { surfacePalette } from './surface-palette';

export const materialPreset = definePreset(Material, {
  semantic: {
    primary: primaryGreen,
    colorScheme: {
      light: {
        surface: surfacePalette
      }
    }
  }
});
